import { EntityDto, IEntityDto } from "../../../utils/models/entity-dto";
import { FieldType } from "@gbs-platform-client/fwk-core";

export class Act extends EntityDto implements IEntityDto {
    Act_Id: string;
    ActName: string;
    Description: string; 
    TotalCount: number;
    IsActive: boolean;
    Document: any;
    Document_Name: string;
    FileName: string;
    Ref_Id: string ;
     CommitteeAct_Id :string

    constructor() {
        super();
        this.Act_Id = "00000000-0000-0000-0000-000000000000";
        this.ActName = "";
        this.Description = "";
        this.TotalCount = 0; 
        this.IsActive = true;
        this.Document = null;
        this.Document_Name = "";
        this.FileName = "";
        this.Ref_Id = "";
this.CommitteeAct_Id='00000000-0000-0000-0000-000000000000';
        this.EntityMetaData = [
            { FieldName: 'ActName', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Act Name is required' },
        ];
    }
}
